<template>
<div class="mt-5 p-4 bg-dark text-white text-center">
  <p><font-awesome-icon icon="far fa-copyright" />  Copyright Elands Nursery {{currentYear}} </p>
</div>
</template>

<script> 
export default {
  name:"FooterBottom",
  computed:{
    currentYear(){
      return new Date().getFullYear()
    }
  },
  data() {
    return {
    };
  },
  methods:{ 
  } 
}
</script>